import React, { useState, useEffect } from "react";
import { AiFillYoutube } from "react-icons/ai";
import { SiGmail } from "react-icons/si";
import { API_URL } from "../App";

const year = new Date().getFullYear();

export default function Footer() {
  const [logos, setLogos] = useState([]);

  useEffect(() => {
    // Obtener los logos del footer desde la API
    fetch(API_URL + "logos-footer/")
      .then((response) => response.json())
      .then((data) => {
        if (data.message === "success") {
          setLogos(data.data);
        }
      })
      .catch((error) => console.error("Error al cargar logos del footer:", error));
  }, []);

  return (
    <footer className="mt-auto text-blue-50 shadow-md bg-dark border-t border-colorPrincipal border-t-blur-2">
      <div className="container px-5 py-8 mx-auto flex items-center sm:flex-row flex-col">
        {/* Logos de instituciones */}
        <div className="flex items-center gap-4">
          {logos.length > 0 ? (
            logos.map((logo) => (
              <a
                key={logo.id}
                href={logo.url}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-80 transition-opacity"
              >
                <img
                  src={logo.logo}
                  alt={logo.nombre}
                  className="h-16 w-auto object-contain"
                  title={logo.nombre}
                />
              </a>
            ))
          ) : (
            <p className="text-sm text-gray-400">Cargando logos...</p>
          )}
        </div>

        <p className="text-sm text-blue-50 sm:ml-4 sm:pl-4 sm:border-l-2 sm:border-gray-200 sm:py-2 sm:mt-0 mt-4">
          © 2018 - {year} Copyright: Automatic Data-driven Analytics laboratory
        </p>

        <span className="inline-flex sm:ml-auto sm:mt-0 mt-4 justify-center sm:justify-start">
          <a
            className="text-gray-500 hover:text-blue-400"
            href="mailto:adalab@unillanos.edu.co"
          >
            <svg
              fill="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              className="w-12 h-14"
              viewBox="0 0 24 24"
            >
              <SiGmail />
            </svg>
          </a>

          <a
            className="ml-3 text-gray-500 hover:text-red-600"
            href="https://www.youtube.com/@automaticdata-drivenanalyt573"
            target="_blank"
            rel="noreferrer"
          >
            <svg
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              className="w-16 h-16"
              viewBox="0 0 24 24"
            >
              <AiFillYoutube />
            </svg>
          </a>
        </span>
      </div>
    </footer>
  );
}
